// Bahagi ng delivery-picker module set (dating monolitikong
// cart-delivery-picker.js, hinati by-responsibility 2026-08-24 — PURE
// REFACTOR, walang behavior change). Shared namespace:
// window.FlowercartDeliveryPicker (DP); mauna ang delivery-picker-state-config.js
// sa load order.
//
// Saklaw ng file na ito: error display (toggleError, scrollErrorIntoView).
(function () {
  const DP = (window.FlowercartDeliveryPicker = window.FlowercartDeliveryPicker || {});
  const state = DP.state;

  function toggleError(message) {
    const { errorDiv } = state.elements;
    if (!errorDiv) return;

    if (message) {
      errorDiv.textContent = message;
      errorDiv.style.display = "block";
    } else {
      errorDiv.textContent = "";
      errorDiv.style.display = "none";
    }
  }

  // Distinct from toggleError(): this is a persistent banner (schedule fetch
  // failed), not a transient click-validation message, so it needs its own
  // retry affordance instead of plain text. Rebuilds the DOM each call —
  // toggleError(null) safely clears it since it only ever sets textContent.
  function showScheduleLoadError() {
    const { errorDiv } = state.elements;
    if (!errorDiv) return;

    errorDiv.textContent = "";

    const message = document.createElement("span");
    message.className = "delivery-error__message";
    message.textContent = "We couldn't load the delivery schedule.";

    const retryBtn = document.createElement("button");
    retryBtn.type = "button";
    retryBtn.className = "delivery-error__retry";
    retryBtn.textContent = "Retry";
    retryBtn.addEventListener("click", () => {
      void DP.refreshScheduleRules();
    });

    errorDiv.appendChild(message);
    errorDiv.appendChild(retryBtn);
    errorDiv.style.display = "flex";
  }

  // When the checkout tap comes from the mobile sticky bar, the error div is
  // usually far above the viewport (live finding 2026-07-28: -330px) — the
  // customer sees no feedback at all. Scroll it into view when off-screen.
  function scrollErrorIntoView() {
    const { errorDiv } = state.elements;
    if (!errorDiv || errorDiv.style.display === "none") return;
    const rect = errorDiv.getBoundingClientRect();
    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top < 0 || rect.bottom > viewportH) {
      errorDiv.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  DP.toggleError = toggleError;
  DP.showScheduleLoadError = showScheduleLoadError;
  DP.scrollErrorIntoView = scrollErrorIntoView;
})();
